import { LOGO_SVG } from '@/src/constants/common';
import { RoutePath } from '@/src/RoutePath';
import { useUser } from '@/src/store/user.context';
import { getNavMenuForUser } from '@/src/utils/navMenu.utils';
import { SideNavigation, SideNavigationProps, TextContent } from '@amzn/awsui-components-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface LinkInfoProps {
  description: string;
}

const LinkInfo: React.FC<LinkInfoProps> = (props) => {
  return (
    <TextContent>
      <small>{props.description}</small>
    </TextContent>
  );
};

export const MobileSideNav: React.FC = () => {
  const { user } = useUser();
  const { t } = useTranslation();

  const navMenu = useMemo(() => {
    return getNavMenuForUser(user);
  }, [user]);

  const navMenuItems: SideNavigationProps.Item[] = navMenu.map((item) => {
    if (item.subMenuItems && item.subMenuItems.length) {
      return {
        type: 'section',
        text: t(item.text),
        items: item.subMenuItems.map((subMenuItem) => ({
          type: 'link',
          href: subMenuItem.href || '',
          text: t(subMenuItem.text),
          info: <LinkInfo description={t(subMenuItem.description)} />,
        })),
      };
    }

    return {
      type: 'link',
      href: item.href || '',
      text: t(item.text),
    };
  });

  return (
    <SideNavigation
      header={{
        href: RoutePath.ROOT,
        text: 'Jam',
        logo: {
          src: LOGO_SVG,
          alt: 'AWS',
        },
      }}
      items={navMenuItems}
    />
  );
};
